import { useQuery } from "@tanstack/react-query";
import { getLatestStatement, getStatementPayload } from "../api/statement.js";
import type {
  StatementVersionSummary,
  StatementPayload,
} from "../api/product-types.js";

export function useLatestStatement(websiteId: string | undefined) {
  return useQuery<StatementVersionSummary | null>({
    queryKey: ["statement", websiteId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      return getLatestStatement(websiteId);
    },
    enabled: websiteId != null,
  });
}

export function useStatementPayload(
  websiteId: string | undefined,
  versionId: string | undefined,
) {
  return useQuery<StatementPayload | null>({
    queryKey: ["statement-payload", websiteId, versionId],
    queryFn: () => {
      if (!websiteId) throw new Error("websiteId is required");
      if (!versionId) throw new Error("versionId is required");
      return getStatementPayload(websiteId, versionId);
    },
    enabled: websiteId != null && versionId != null,
  });
}
